import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import { Dispatch } from 'redux';
import { push } from 'connected-react-router';
import { isNullOrUndefined } from 'util';

type LoggedOutProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

function deleteCookie(name: string, domain: string = "", path: string = "/") {
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
    if (domain.trim() != "") {
        cookieString += ` domain=${domain};`;
    }
    document.cookie = cookieString;
}

class LoggedOut extends React.Component<LoggedOutProps, any> {
    constructor(props: LoggedOutProps) {
        super(props);
        console.log('clear session storage');
        deleteCookie("gdscp_userAuthenticated");
        sessionStorage.removeItem('gdscp_userToken');

        props.push('/');
    }

    public render() {
        return <>Logging Out...</>;
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedOut);
